import c from "./styles.module.scss";
import MarkdownBlock from "../markdownBlock";
import Container from "../container/index";

const PostPreview = ({ post }) => {
  const { slug, title, metadata } = post;
  const imageUrl = post.seoImage || `https://g-factory.kz/media/${slug}.avif`;

  return (
    <div className={c.preview}>
      <Container>
        <div className={c.inner}>
          <div className={c.billboard}>
            <img
              alt={slug}
              src={imageUrl}
              className={c.image}
            />
          </div>

          <div className={c.info}>
            <h1>{title}</h1>

            {metadata?.["post-body"] ? (
              <MarkdownBlock body={metadata["post-body"]} />
            ) : (
              <p>Пост не найден</p>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default PostPreview;
